import { Button } from "@/components";
import { useState } from "react";
import { HiOutlineDownload, HiOutlineUpload } from "react-icons/hi";
import { SheetClose } from "@/components/ui/sheet";
import { UploadInput } from "@/components";
import { useAlert, useConfirmationDialog } from "@/";
import { useDispatch } from "react-redux";
import { upsertRates } from "../../../app/Slices";
const UpdateRateChart = ({ onSubmit, setSheetOpen = () => {} }) => {
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const dispatch = useDispatch();
  const handleChange = (key, value) => {
    setSelectedFile((prev) => ({ ...prev, [key]: value }));
  };
  const [selectedFile, setSelectedFile] = useState({
    rateFile: null,
  });
  const handleSubmit = async () => {
    if (!selectedFile.rateFile) {
      await alert("Please select a file before uploading.");
      return;
    }
    await confirm("Are you sure you want to upload the rates? ");
    try {
      const action = await dispatch(
        upsertRates({ file: selectedFile.rateFile })
      );

      if (upsertRates.fulfilled.match(action)) {
        await alert("Rates uploaded successfully");
        setSheetOpen(false); // Close sheet after alert
      } else {
        console.error("Rate Upsert Failed:", action.payload);
        await alert(action.payload || "Rate Upsert Failed");
      }
    } catch (error) {
      console.error("API Error:::", error.message);
      await alert("An error occurred while uploading the rates.");
    }
  };

  return (
    <div className="flex flex-col gap-10 pl-2">
      <div className="flex flex-col gap-6">
        {/* Step 1 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">1.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Download Rate sheet
            </p>
          </div>
          <div className="flex gap-2 justify-start items-center ml-6">
            <Button
              variant="default"
              size="sm"
              icon={HiOutlineDownload}
              onClick={() => {
                window.location.href =
                  "https://api.indiancouriercompany.com/samples/Final_Rate_Chart_ICC.csv";
              }}
            >
              Download Sheet
            </Button>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">2.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Upload updated rate sheet
            </p>
          </div>
          <div className="flex gap-2 justify-center items-center ml-6">
            <UploadInput
              label=""
              placeholder="Upload Rate Sheet"
              note="Note: Only .csv file is allowed"
              accept=".csv"
              onChange={(file) => handleChange("rateFile", file)}
            />
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="flex gap-2 justify-end items-center mt-4">
        <SheetClose asChild>
          <Button variant="outline" size="sm">
            Cancel
          </Button>
        </SheetClose>
        <Button
          variant="default"
          size="sm"
          icon={HiOutlineUpload}
          onClick={handleSubmit}
        >
          Upload
        </Button>
      </div>
      <AlertDialog />
      <ConfirmationModal />
    </div>
  );
};

export default UpdateRateChart;
